import envConfig from '../../static/config';
import config from '../config';
import SecurityDeviceActionCreators from '../actions/SecurityDeviceActionCreator';
import ApiUtils from './ApiUtils';

class SecurityDeviceApiUtils {
  static getSecurityDevices() {
    const url = envConfig.stubConfig
      ? envConfig.stubConfig.securityDevicesStub.GetSecurityDevicesConnection
      : `${envConfig.apiBaseUrlPAAS}/ibapi/v2/banks/{bank-id}/user/security_devices`;

    // empty error callback required in order to avoid global error handler catching 500/404.
    return ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.securityDevices,
        method: 'GET',
        url,
        addAuthToken: true,
      },
      (body) => {
        SecurityDeviceActionCreators.handleGetSecurityDevicesSuccess(body);
      },
      () => {}
    );
  }
}

export default SecurityDeviceApiUtils;
